import { BOOKS, VERSIONS } from "../../utils/constants";
import { Scripture } from "../types";

export const FirstPeter: Scripture = {
  "version": VERSIONS.KJV,
  "book": BOOKS.FIRST_PETER,
  "chapters": [
    {
      "chapter": "1",
      "verses": [
        {
          "verse": "1",
          "text": "Peter, an apostle of Jesus Christ, to the strangers scattered throughout Pontus, Galatia, Cappadocia, Asia, and Bithynia,"
        },
        {
          "verse": "2",
          "text": "Elect according to the foreknowledge of God the Father, through sanctification of the Spirit, unto obedience and sprinkling of the blood of Jesus Christ: Grace unto you, and peace, be multiplied."
        },
        {
          "verse": "3",
          "text": "Blessed be the God and Father of our Lord Jesus Christ, which according to his abundant mercy hath begotten us again unto a lively hope by the resurrection of Jesus Christ from the dead,"
        },
        {
          "verse": "4",
          "text": "To an inheritance incorruptible, and undefiled, and that fadeth not away, reserved in heaven for you,"
        },
        {
          "verse": "5",
          "text": "Who are kept by the power of God through faith unto salvation ready to be revealed in the last time."
        },
        {
          "verse": "6",
          "text": "Wherein ye greatly rejoice, though now for a season, if need be, ye are in heaviness through manifold temptations:"
        },
        {
          "verse": "7",
          "text": "That the trial of your faith, being much more precious than of gold that perisheth, though it be tried with fire, might be found unto praise and honour and glory at the appearing of Jesus Christ:"
        },
        {
          "verse": "8",
          "text": "Whom having not seen, ye love; in whom, though now ye see him not, yet believing, ye rejoice with joy unspeakable and full of glory:"
        },
        {
          "verse": "9",
          "text": "Receiving the end of your faith, even the salvation of your souls."
        },
        {
          "verse": "10",
          "text": "Of which salvation the prophets have enquired and searched diligently, who prophesied of the grace that should come unto you:"
        },
        {
          "verse": "11",
          "text": "Searching what, or what manner of time the Spirit of Christ which was in them did signify, when it testified beforehand the sufferings of Christ, and the glory that should follow."
        },
        {
          "verse": "12",
          "text": "Unto whom it was revealed, that not unto themselves, but unto us they did minister the things, which are now reported unto you by them that have preached the gospel unto you with the Holy Ghost sent down from heaven; which things the angels desire to look into."
        },
        {
          "verse": "13",
          "text": "Wherefore gird up the loins of your mind, be sober, and hope to the end for the grace that is to be brought unto you at the revelation of Jesus Christ;"
        },
        {
          "verse": "14",
          "text": "As obedient children, not fashioning yourselves according to the former lusts in your ignorance:"
        },
        {
          "verse": "15",
          "text": "But as he which hath called you is holy, so be ye holy in all manner of conversation;"
        },
        {
          "verse": "16",
          "text": "Because it is written, Be ye holy; for I am holy."
        },
        {
          "verse": "17",
          "text": "And if ye call on the Father, who without respect of persons judgeth according to every man\u2019s work, pass the time of your sojourning here in fear:"
        },
        {
          "verse": "18",
          "text": "Forasmuch as ye know that ye were not redeemed with corruptible things, as silver and gold, from your vain conversation received by tradition from your fathers;"
        },
        {
          "verse": "19",
          "text": "But with the precious blood of Christ, as of a lamb without blemish and without spot:"
        },
        {
          "verse": "20",
          "text": "Who verily was foreordained before the foundation of the world, but was manifest in these last times for you,"
        },
        {
          "verse": "21",
          "text": "Who by him do believe in God, that raised him up from the dead, and gave him glory; that your faith and hope might be in God."
        },
        {
          "verse": "22",
          "text": "Seeing ye have purified your souls in obeying the truth through the Spirit unto unfeigned love of the brethren, see that ye love one another with a pure heart fervently:"
        },
        {
          "verse": "23",
          "text": "Being born again, not of corruptible seed, but of incorruptible, by the word of God, which liveth and abideth for ever."
        },
        {
          "verse": "24",
          "text": "For all flesh is as grass, and all the glory of man as the flower of grass. The grass withereth, and the flower thereof falleth away:"
        },
        {
          "verse": "25",
          "text": "But the word of the Lord endureth for ever. And this is the word which by the gospel is preached unto you."
        }
      ]
    },
    {
      "chapter": "2",
      "verses": [
        {
          "verse": "1",
          "text": "Wherefore laying aside all malice, and all guile, and hypocrisies, and envies, and all evil speakings,"
        },
        {
          "verse": "2",
          "text": "As newborn babes, desire the sincere milk of the word, that ye may grow thereby:"
        },
        {
          "verse": "3",
          "text": "If so be ye have tasted that the Lord is gracious."
        },
        {
          "verse": "4",
          "text": "To whom coming, as unto a living stone, disallowed indeed of men, but chosen of God, and precious,"
        },
        {
          "verse": "5",
          "text": "Ye also, as lively stones, are built up a spiritual house, an holy priesthood, to offer up spiritual sacrifices, acceptable to God by Jesus Christ."
        },
        {
          "verse": "6",
          "text": "Wherefore also it is contained in the scripture, Behold, I lay in Sion a chief corner stone, elect, precious: and he that believeth on him shall not be confounded."
        },
        {
          "verse": "7",
          "text": "Unto you therefore which believe he is precious: but unto them which be disobedient, the stone which the builders disallowed, the same is made the head of the corner,"
        },
        {
          "verse": "8",
          "text": "And a stone of stumbling, and a rock of offence, even to them which stumble at the word, being disobedient: whereunto also they were appointed."
        },
        {
          "verse": "9",
          "text": "But ye are a chosen generation, a royal priesthood, an holy nation, a peculiar people; that ye should shew forth the praises of him who hath called you out of darkness into his marvellous light:"
        },
        {
          "verse": "10",
          "text": "Which in time past were not a people, but are now the people of God: which had not obtained mercy, but now have obtained mercy."
        },
        {
          "verse": "11",
          "text": "Dearly beloved, I beseech you as strangers and pilgrims, abstain from fleshly lusts, which war against the soul;"
        },
        {
          "verse": "12",
          "text": "Having your conversation honest among the Gentiles: that, whereas they speak against you as evildoers, they may by your good works, which they shall behold, glorify God in the day of visitation."
        },
        {
          "verse": "13",
          "text": "Submit yourselves to every ordinance of man for the Lord\u2019s sake: whether it be to the king, as supreme;"
        },
        {
          "verse": "14",
          "text": "Or unto governors, as unto them that are sent by him for the punishment of evildoers, and for the praise of them that do well."
        },
        {
          "verse": "15",
          "text": "For so is the will of God, that with well doing ye may put to silence the ignorance of foolish men:"
        },
        {
          "verse": "16",
          "text": "As free, and not using your liberty for a cloke of maliciousness, but as the servants of God."
        },
        {
          "verse": "17",
          "text": "Honour all men. Love the brotherhood. Fear God. Honour the king."
        },
        {
          "verse": "18",
          "text": "Servants, be subject to your masters with all fear; not only to the good and gentle, but also to the froward."
        },
        {
          "verse": "19",
          "text": "For this is thankworthy, if a man for conscience toward God endure grief, suffering wrongfully."
        },
        {
          "verse": "20",
          "text": "For what glory is it, if, when ye be buffeted for your faults, ye shall take it patiently? but if, when ye do well, and suffer for it, ye take it patiently, this is acceptable with God."
        },
        {
          "verse": "21",
          "text": "For even hereunto were ye called: because Christ also suffered for us, leaving us an example, that ye should follow his steps:"
        },
        {
          "verse": "22",
          "text": "Who did no sin, neither was guile found in his mouth:"
        },
        {
          "verse": "23",
          "text": "Who, when he was reviled, reviled not again; when he suffered, he threatened not; but committed himself to him that judgeth righteously:"
        },
        {
          "verse": "24",
          "text": "Who his own self bare our sins in his own body on the tree, that we, being dead to sins, should live unto righteousness: by whose stripes ye were healed."
        },
        {
          "verse": "25",
          "text": "For ye were as sheep going astray; but are now returned unto the Shepherd and Bishop of your souls."
        }
      ]
    },
    {
      "chapter": "3",
      "verses": [
        {
          "verse": "1",
          "text": "Likewise, ye wives, be in subjection to your own husbands; that, if any obey not the word, they also may without the word be won by the conversation of the wives;"
        },
        {
          "verse": "2",
          "text": "While they behold your chaste conversation coupled with fear."
        },
        {
          "verse": "3",
          "text": "Whose adorning let it not be that outward adorning of plaiting the hair, and of wearing of gold, or of putting on of apparel;"
        },
        {
          "verse": "4",
          "text": "But let it be the hidden man of the heart, in that which is not corruptible, even the ornament of a meek and quiet spirit, which is in the sight of God of great price."
        },
        {
          "verse": "5",
          "text": "For after this manner in the old time the holy women also, who trusted in God, adorned themselves, being in subjection unto their own husbands:"
        },
        {
          "verse": "6",
          "text": "Even as Sara obeyed Abraham, calling him lord: whose daughters ye are, as long as ye do well, and are not afraid with any amazement."
        },
        {
          "verse": "7",
          "text": "Likewise, ye husbands, dwell with them according to knowledge, giving honour unto the wife, as unto the weaker vessel, and as being heirs together of the grace of life; that your prayers be not hindered."
        },
        {
          "verse": "8",
          "text": "Finally, be ye all of one mind, having compassion one of another, love as brethren, be pitiful, be courteous:"
        },
        {
          "verse": "9",
          "text": "Not rendering evil for evil, or railing for railing: but contrariwise blessing; knowing that ye are thereunto called, that ye should inherit a blessing."
        },
        {
          "verse": "10",
          "text": "For he that will love life, and see good days, let him refrain his tongue from evil, and his lips that they speak no guile:"
        },
        {
          "verse": "11",
          "text": "Let him eschew evil, and do good; let him seek peace, and ensue it."
        },
        {
          "verse": "12",
          "text": "For the eyes of the Lord are over the righteous, and his ears are open unto their prayers: but the face of the Lord is against them that do evil."
        },
        {
          "verse": "13",
          "text": "And who is he that will harm you, if ye be followers of that which is good?"
        },
        {
          "verse": "14",
          "text": "But and if ye suffer for righteousness\u2019 sake, happy are ye: and be not afraid of their terror, neither be troubled;"
        },
        {
          "verse": "15",
          "text": "But sanctify the Lord God in your hearts: and be ready always to give an answer to every man that asketh you a reason of the hope that is in you with meekness and fear:"
        },
        {
          "verse": "16",
          "text": "Having a good conscience; that, whereas they speak evil of you, as of evildoers, they may be ashamed that falsely accuse your good conversation in Christ."
        },
        {
          "verse": "17",
          "text": "For it is better, if the will of God be so, that ye suffer for well doing, than for evil doing."
        },
        {
          "verse": "18",
          "text": "For Christ also hath once suffered for sins, the just for the unjust, that he might bring us to God, being put to death in the flesh, but quickened by the Spirit:"
        },
        {
          "verse": "19",
          "text": "By which also he went and preached unto the spirits in prison;"
        },
        {
          "verse": "20",
          "text": "Which sometime were disobedient, when once the longsuffering of God waited in the days of Noah, while the ark was a preparing, wherein few, that is, eight souls were saved by water."
        },
        {
          "verse": "21",
          "text": "The like figure whereunto even baptism doth also now save us (not the putting away of the filth of the flesh, but the answer of a good conscience toward God,) by the resurrection of Jesus Christ:"
        },
        {
          "verse": "22",
          "text": "Who is gone into heaven, and is on the right hand of God; angels and authorities and powers being made subject unto him."
        }
      ]
    },
    {
      "chapter": "4",
      "verses": [
        {
          "verse": "1",
          "text": "Forasmuch then as Christ hath suffered for us in the flesh, arm yourselves likewise with the same mind: for he that hath suffered in the flesh hath ceased from sin;"
        },
        {
          "verse": "2",
          "text": "That he no longer should live the rest of his time in the flesh to the lusts of men, but to the will of God."
        },
        {
          "verse": "3",
          "text": "For the time past of our life may suffice us to have wrought the will of the Gentiles, when we walked in lasciviousness, lusts, excess of wine, revellings, banquetings, and abominable idolatries:"
        },
        {
          "verse": "4",
          "text": "Wherein they think it strange that ye run not with them to the same excess of riot, speaking evil of you:"
        },
        {
          "verse": "5",
          "text": "Who shall give account to him that is ready to judge the quick and the dead."
        },
        {
          "verse": "6",
          "text": "For for this cause was the gospel preached also to them that are dead, that they might be judged according to men in the flesh, but live according to God in the spirit."
        },
        {
          "verse": "7",
          "text": "But the end of all things is at hand: be ye therefore sober, and watch unto prayer."
        },
        {
          "verse": "8",
          "text": "And above all things have fervent charity among yourselves: for charity shall cover the multitude of sins."
        },
        {
          "verse": "9",
          "text": "Use hospitality one to another without grudging."
        },
        {
          "verse": "10",
          "text": "As every man hath received the gift, even so minister the same one to another, as good stewards of the manifold grace of God."
        },
        {
          "verse": "11",
          "text": "If any man speak, let him speak as the oracles of God; if any man minister, let him do it as of the ability which God giveth: that God in all things may be glorified through Jesus Christ, to whom be praise and dominion for ever and ever. Amen."
        },
        {
          "verse": "12",
          "text": "Beloved, think it not strange concerning the fiery trial which is to try you, as though some strange thing happened unto you:"
        },
        {
          "verse": "13",
          "text": "But rejoice, inasmuch as ye are partakers of Christ\u2019s sufferings; that, when his glory shall be revealed, ye may be glad also with exceeding joy."
        },
        {
          "verse": "14",
          "text": "If ye be reproached for the name of Christ, happy are ye; for the spirit of glory and of God resteth upon you: on their part he is evil spoken of, but on your part he is glorified."
        },
        {
          "verse": "15",
          "text": "But let none of you suffer as a murderer, or as a thief, or as an evildoer, or as a busybody in other men\u2019s matters."
        },
        {
          "verse": "16",
          "text": "Yet if any man suffer as a Christian, let him not be ashamed; but let him glorify God on this behalf."
        },
        {
          "verse": "17",
          "text": "For the time is come that judgment must begin at the house of God: and if it first begin at us, what shall the end be of them that obey not the gospel of God?"
        },
        {
          "verse": "18",
          "text": "And if the righteous scarcely be saved, where shall the ungodly and the sinner appear?"
        },
        {
          "verse": "19",
          "text": "Wherefore let them that suffer according to the will of God commit the keeping of their souls to him in well doing, as unto a faithful Creator."
        }
      ]
    },
    {
      "chapter": "5",
      "verses": [
        {
          "verse": "1",
          "text": "The elders which are among you I exhort, who am also an elder, and a witness of the sufferings of Christ, and also a partaker of the glory that shall be revealed:"
        },
        {
          "verse": "2",
          "text": "Feed the flock of God which is among you, taking the oversight thereof, not by constraint, but willingly; not for filthy lucre, but of a ready mind;"
        },
        {
          "verse": "3",
          "text": "Neither as being lords over God\u2019s heritage, but being ensamples to the flock."
        },
        {
          "verse": "4",
          "text": "And when the chief Shepherd shall appear, ye shall receive a crown of glory that fadeth not away."
        },
        {
          "verse": "5",
          "text": "Likewise, ye younger, submit yourselves unto the elder. Yea, all of you be subject one to another, and be clothed with humility: for God resisteth the proud, and giveth grace to the humble."
        },
        {
          "verse": "6",
          "text": "Humble yourselves therefore under the mighty hand of God, that he may exalt you in due time:"
        },
        {
          "verse": "7",
          "text": "Casting all your care upon him; for he careth for you."
        },
        {
          "verse": "8",
          "text": "Be sober, be vigilant; because your adversary the devil, as a roaring lion, walketh about, seeking whom he may devour:"
        },
        {
          "verse": "9",
          "text": "Whom resist stedfast in the faith, knowing that the same afflictions are accomplished in your brethren that are in the world."
        },
        {
          "verse": "10",
          "text": "But the God of all grace, who hath called us unto his eternal glory by Christ Jesus, after that ye have suffered a while, make you perfect, stablish, strengthen, settle you."
        },
        {
          "verse": "11",
          "text": "To him be glory and dominion for ever and ever. Amen."
        },
        {
          "verse": "12",
          "text": "By Silvanus, a faithful brother unto you, as I suppose, I have written briefly, exhorting, and testifying that this is the true grace of God wherein ye stand."
        },
        {
          "verse": "13",
          "text": "The church that is at Babylon, elected together with you, saluteth you; and so doth Marcus my son."
        },
        {
          "verse": "14",
          "text": "Greet ye one another with a kiss of charity. Peace be with you all that are in Christ Jesus. Amen."
        }
      ]
    }
  ]
}
